const E = {
  'Submit a Job': 'Submit a Job',
  'ETA at the lab date should not be on Weekends': 'ETA at the lab date should not be on Weekends',
  'ETA at the lab date should not be on Holidays': 'ETA at the lab date should not be on Holidays',
  'Results required by date should not be on Weekends': 'Results required by date should not be on Weekends',
  'Results required by date should not be on Holidays': 'Results required by date should not be on Holidays',
  Destination: 'Destination',
  'ETA at the lab': 'ETA at the lab',
  'Shipping Method': 'Shipping Method',
  'Waybill #': 'Waybill #',
  'Rush Job': 'Rush Job',
  'Service Level': 'Service Level',
  'Select Service Level': 'Select Service Level',
  'Results Required By': 'Results Required By',
  SamplingDateWarning: 'ETA is prior to sampling date',
  BottleOrderinformation: 'BOTTLE ORDER INFORMATION',
  'eCoc Information': 'eCOC INFORMATION',
  'BV lab performing Analysis': 'BV Lab Performing Analysis',
  OrderComment: 'Order Comment',
  'Fill the Shipping Detail': 'Fill the Shipping Detail.',
  'Receipt #': 'Receipt #',
};

const F = {
  'Submit a Job': 'Envoyer un dossier',
  'ETA at the lab date should not be on Weekends': 'La date d’arrivée au laboratoire ne doit pas être un jour de fin de semaine',
  'ETA at the lab date should not be on Holidays': 'La date d’arrivée au laboratoire ne doit pas être un jour férié',
  'Results required by date should not be on Weekends': 'La date de transmission des résultats ne doit pas être un jour de fin de semaine',
  'Results required by date should not be on Holidays': 'La date de transmission des résultats ne doit pas être un jour férié',
  Destination: 'Destination',
  'ETA at the lab': 'Date d’arrivée prévue au laboratoire',
  'Shipping Method': 'Méthode d’envoi',
  'Waybill #': 'No de bordereau d’expédition',
  'Rush Job': 'Dossier urgent',
  'Service Level': 'Délai requis',
  'Select Service Level': 'Sélectionner un délai requis',
  'Results Required By': 'Résultats requis pour le',
  SamplingDateWarning: "L'ETA est avant la date d’échantillonnage",
  BottleOrderinformation: 'INFORMATIONS SUR LA COMMANDE DE BOUTEILLES',
  'eCoc Information': 'INFORMATIONS eCOC',
  'BV lab performing Analysis': 'BV Lab effectuant une analyse',
  OrderComment: 'Commentaire de commande',
  'Fill the Shipping Detail': 'Remplissez les détails de l’expédition.',
  'Receipt #': 'Reçu #',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/formsShipping.js